<div class="stepper-instruction">
	<div class="contact-form-container">
		<div class="content-body">
			<div class="card tracking-timeline">
				<kendo-stepper
					class="custom-stepper"
					[steps]="steps"
					[(currentStep)]="currentStep"
					stepType="full"
					orientation="horizontal"
					(activate)="activate($event)"
					(currentStepChange)="currentStepChange($event)"
				></kendo-stepper>
			</div>
			<div class="header" *ngIf="!(currentStep === 2)">
				<div class="ref-number">
					<span class="ref-label">{{ dairyBookingConstants.trackingNumber }} : </span>
					<span class="ref-value">{{ refNumber }}</span>
				</div>
			</div>
			<div class="main-form">
				<div class="address-section" *ngIf="!(currentStep === 2)">
					<div class="section-title">
						<i class="fas fa-map-marker-alt"></i>
						<h3>{{ dairyBookingConstants.address }}</h3>
					</div>
					<p>{{ address }}</p>
					<p class="amend-note">
						{{ dairyBookingConstants.amendNote }}
						<span class="icon">
							<i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
						</span>
					</p>
				</div>

				<div class="contact-section" *ngIf="currentStep === 0">
					<div class="section-title">
						<h3>{{ dairyBookingConstants.contactInformation }}</h3>
					</div>
					<form #contactForm="ngForm" (ngSubmit)="onUpdate()" novalidate autocomplete="off">
						<div class="form-row">
							<mat-form-field appearance="outline" class="form-group">
								<mat-label>{{ dairyBookingConstants.email }}</mat-label>
								<input matInput type="email" name="email" [(ngModel)]="contactFormPayload.email" />
							</mat-form-field>

							<mat-form-field appearance="outline" class="form-group">
								<mat-label>{{ dairyBookingConstants.preferredContact }}</mat-label>
								<input
									matInput
									type="text"
									name="preferredContact"
									[(ngModel)]="contactFormPayload.preferredContactNumber"
									#contactCtrl="ngModel"
									minlength="11"
									maxlength="11"
									pattern="^07\d{9}$"
								/>
								<mat-error *ngIf="contactCtrl.hasError('pattern') && contactCtrl.touched">
									{{ dairyBookingConstants.contactError }}
								</mat-error>
							</mat-form-field>
						</div>
						<div class="form-row">
							<mat-form-field appearance="outline" class="form-group">
								<mat-label>{{ dairyBookingConstants.mobileNumber }}</mat-label>
								<input
									matInput
									type="text"
									name="mobileNumber"
									[(ngModel)]="contactFormPayload.mobileNumber"
									#mobileCtrl="ngModel"
									minlength="11"
									maxlength="11"
									required
									pattern="^07\d{9}$"
								/>
								<mat-error *ngIf="mobileCtrl.hasError('required') && mobileCtrl.touched">
									{{ dairyBookingConstants.mobileNumberRequired }}
								</mat-error>
								<mat-error *ngIf="mobileCtrl.hasError('pattern') && mobileCtrl.touched">
									{{ dairyBookingConstants.contactError }}
								</mat-error>
							</mat-form-field>

							<mat-form-field appearance="outline" class="form-group">
								<mat-label>{{ dairyBookingConstants.homeNumber }}</mat-label>
								<input
									matInput
									type="text"
									name="homeNumber"
									[(ngModel)]="contactFormPayload.homeNumber"
									#homeCtrl="ngModel"
									minlength="11"
									maxlength="11"
									pattern="^07\d{9}$"
								/>
								<mat-error *ngIf="homeCtrl.hasError('pattern') && homeCtrl.touched">
									{{ dairyBookingConstants.homeAndWorkError }}
								</mat-error>
							</mat-form-field>
						</div>
						<div class="form-row">
							<mat-form-field appearance="outline" class="form-group full-width">
								<mat-label>{{ dairyBookingConstants.workNumber }}</mat-label>
								<input
									matInput
									type="text"
									name="workNumber"
									[(ngModel)]="contactFormPayload.workNumber"
									#workCtrl="ngModel"
									minlength="11"
									maxlength="11"
									pattern="^07\d{9}$"
								/>
								<mat-error *ngIf="workCtrl.hasError('pattern') && workCtrl.touched">
									{{ dairyBookingConstants.homeAndWorkError }}
								</mat-error>
							</mat-form-field>
						</div>
					</form>
				</div>

				<div class="special-instructions-section" *ngIf="currentStep === 0">
					<div class="section-title">
						<h3>{{ dairyBookingConstants.specialInstructions }}</h3>
					</div>

					<div class="add-instructions-input">
						<mat-form-field appearance="outline" class="form-group full-width">
							<mat-label>{{ dairyBookingConstants.addInstructions }}</mat-label>
							<input matInput [(ngModel)]="contactFormPayload.specialInstructionsText" name="specialInstructionsInput" />
						</mat-form-field>
					</div>
				</div>

				<!-- pre delivery servey commented due to out of scope-->
				<!-- <div class="location-form" *ngIf="currentStep === 1">
					<div class="form-group checkbox-group">
						<div class="hint"><i class="fa-regular fa-lightbulb"></i> {{ dairyBookingConstants.preDeliveryHint }}</div>
					</div>

					<div class="form-group">
						<p class="label">{{ dairyBookingConstants.living }}</p>
						<label>
							<input type="radio" name="living" value="Apartment" [(ngModel)]="contactFormPayload.livingType" />
							{{ dairyBookingConstants.apartment }}
						</label>
						<label>
							<input type="radio" name="living" value="Individual Properties" [(ngModel)]="contactFormPayload.livingType" />
							{{ dairyBookingConstants.individual }}
						</label>
						<label>
							<input type="radio" name="living" value="Flat" [(ngModel)]="contactFormPayload.livingType" />
							{{ dairyBookingConstants.flat }}
						</label>
					</div>

					<div class="form-group">
						<p class="label">{{ dairyBookingConstants.rise }}</p>
						<label>
							<input type="radio" name="rise" value="High-Rise Building" [(ngModel)]="contactFormPayload.riseType" />
							{{ dairyBookingConstants.highRise }}
						</label>
						<label>
							<input type="radio" name="rise" value="Low-rise building" [(ngModel)]="contactFormPayload.riseType" />
							{{ dairyBookingConstants.lowRise }}
						</label>
					</div>

					<div class="form-group">
						<p class="label">{{ dairyBookingConstants.parking }}</p>
						<label>
							<input type="radio" name="parking" value="Yes" [(ngModel)]="contactFormPayload.parkingAvailable" />
							{{ dairyBookingConstants.yes }}
						</label>
						<label>
							<input type="radio" name="parking" value="No" [(ngModel)]="contactFormPayload.parkingAvailable" />
							{{ dairyBookingConstants.no }}
						</label>
					</div>

					<div class="form-group">
						<p class="label">{{ dairyBookingConstants.vehical }}</p>
						<label>
							<input type="radio" name="vehical" value="Yes" [(ngModel)]="contactFormPayload.vehicalCanGo" />
							{{ dairyBookingConstants.yes }}
						</label>
						<label>
							<input type="radio" name="vehical" value="No" [(ngModel)]="contactFormPayload.vehicalCanGo" />
							{{ dairyBookingConstants.no }}
						</label>
					</div>
				</div> -->

				<!-- Book a date -->
				<div class="book-date" *ngIf="currentStep === 1">
					<!-- Section Title -->
					<h3 class="section-title">{{ dairyBookingConstants.bookDate }}</h3>
					<div class="info-box">
						<div class="info-header">
							<i class="fa fa-lightbulb"></i>
							<div>
								<strong>{{ dairyBookingConstants.chooseDeliveryDay }}</strong>
								<p class="subtitle">{{ dairyBookingConstants.chooseDeliveryDaySubtitle }}</p>
								<p class="description">
									{{ dairyBookingConstants.chooseDeliveryDayDescription }}
								</p>
							</div>
						</div>
					</div>
					<!-- Date Picker -->
					<mat-form-field appearance="outline" class="date-picker-field">
						<mat-label>{{ dairyBookingConstants.selectDate }}</mat-label>
						<input
							matInput
							name="selectedDate"
							#datePickerCtrl="ngModel"
							[matDatepicker]="picker"
							[matDatepickerFilter]="dateFilter"
							[(ngModel)]="contactFormPayload.selectedDate"
							(ngModelChange)="onDateSelected($event)"
							placeholder="Select your Date"
							required
						/>
						<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
						<mat-datepicker #picker></mat-datepicker>
						<!-- Show when no slots are available -->
						<mat-error *ngIf="noSlotsAvailable" class="no-slot-msg">
							{{ dairyBookingConstants.noSlotAvailable }}
						</mat-error>
					</mat-form-field>
				</div>

				<!-- booking confirm -->
				<div class="delivery-confirmation" *ngIf="currentStep === 2">
					<lottie-player
						[src]="src"
						background="transparent"
						speed="1"
						style="width: 150px; height: 150px; margin: auto"
						loop
						autoplay
					></lottie-player>
					<h3 class="header-title">{{ dairyBookingConstants.deliveryConfirmed }}</h3>

					<div class="details-card">
						<div class="order-row">
							<span>{{ dairyBookingConstants.confirmDate }}</span>
							<span class="highlight">{{ delivery.confirmedDate }}</span>
						</div>
						<div class="order-row">
							<span>{{ dairyBookingConstants.trackingNumber }}</span>
							<span class="highlight">{{ delivery.refNumber }}</span>
						</div>
						<div class="order-row">
							<span>{{ dairyBookingConstants.productDescription }}</span>
							<span class="highlight">{{ deliveryItem.item_description }}</span>
						</div>
						<div class="order-row">
							<span>{{ dairyBookingConstants.orderFrom }}</span>
							<span class="highlight">{{ wismoDetails?.account_name }}</span>
						</div>
						<div class="order-row">
							<span>{{ dairyBookingConstants.optedServices }}</span>
							<span *ngIf="serviceItems.length; else noService">
								<ng-container *ngFor="let s of serviceItems; let last = last">
									<span class="highlight">{{ s.item_description }}</span>
									<span *ngIf="!last"><br /></span>
								</ng-container>
							</span>
						</div>
						<ng-template #noService>
							<span class="highlight">{{ trackingConstants.noOptedService }}</span>
						</ng-template>
					</div>

					<h3 class="section-title purple">{{ dairyBookingConstants.contactDetails }}</h3>

					<div class="contact-card">
						<p class="contact-name">
							<strong>{{ wismoDetails?.first_name }} {{ wismoDetails?.last_name }}</strong>
						</p>
						<ul class="contact-list">
							<li><i class="fa fa-envelope"></i> {{ wismoDetails?.order_hdr_wismo_info?.order_hdr_wismo_info_item[0].email_address }}</li>
							<li>
								<i class="fa fa-map-marker-alt"></i> {{ wismoDetails?.address_line_1 }} {{ wismoDetails?.address_line_2 }}
							</li>
							<li><i class="fa fa-info-circle"></i> {{ wismoDetails?.contact_phone }}</li>
							<li><i class="fa fa-phone"></i> {{ wismoDetails?.mobile_phone }}</li>
							<li><i class="fa fa-home"></i> {{ wismoDetails?.home_phone }}</li>
							<li><i class="fa fa-briefcase"></i> {{ wismoDetails?.work_phone }}</li>
						</ul>
					</div>
				</div>

				<div class="form-actions" *ngIf="!(currentStep === 2)">
					<div>
						<button class="cancel-btn" (click)="onCancel()">{{ dairyBookingConstants.btnCancel }}</button>
					</div>
					<div>
						<button class="back-btn" (click)="onBack()" *ngIf="currentStep > 0">
							{{ dairyBookingConstants.btnBack }}
						</button>
						<button class="update-btn" (click)="onUpdate()">
							{{ currentStep === 0 ? dairyBookingConstants.btnUpdate : dairyBookingConstants.btnNext }}
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
